import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    GridContainer,
    GridItem11,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

import {
    CardGridEstudo,
} from '../../../business-components/Card/Card'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorDestaque3,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    processaValoresDefaultIniciaisHipotesesRetornoRealProjetoVidaSonhoTracarMetaChart
} from '../estudo-chart/HipotesesRetornoRealProjetoVidaSonhoTracarMetaChartService'

//import {
//    relatorioModoApresentacao,
//} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormProjetoVidaSonhoTracarMeta = ( { values, setFieldValue, handleSubmitAutomatico, estudo, report,
    jsonConfiguracao, indInicial, indFinal, moreLessList } ) => {
    
    const ProjetoVidaSonhoTracarMeta = ( /*props*/ ) => {

        if (values.valorPresenteDeficitSimulacaoMensal === 0 || report) {

            processaValoresDefaultIniciaisHipotesesRetornoRealProjetoVidaSonhoTracarMetaChart(values,
                handleSubmitAutomatico, estudo, report, jsonConfiguracao, LABEL.projetoVidaSonho)
        }
    
        let temValorNecessarioVP = false
        
        estudo.current.projetoVidaSonhoTracarMeta?.forEach( (linhaProjetoVidaSonhoTracarMeta, indexProjetoVidaSonhoTracarMeta) => {
    
            if (
                    (
                        !indFinal ||
                        (indexProjetoVidaSonhoTracarMeta >= indInicial && indexProjetoVidaSonhoTracarMeta <= indFinal)
                    ) &&
                    linhaProjetoVidaSonhoTracarMeta.valorAcumulacaoNecessarioVP !== 0
            ) {
    
                temValorNecessarioVP = true
            }
        })
    
        let headList = [
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.familiar, report),
            },
            {
                colSpan: 6,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoProjetoVidaSonho, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, report),
            },
            {
                colSpan: 5,
                headTitle: 
                    temValorNecessarioVP
                        ?
                            formataTableCellHeadExibeDadosValorDestaque3(
                                LABEL.valorAcumulacaoJaRealizadoVFAbreviado + "/ " + LABEL.valorAcumulacaoNecessarioVP, report)
                        :
                            formataTableCellHeadExibeDadosValor(LABEL.valorAcumulacaoJaRealizadoVFAbreviado, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorAcumulacaoPendenteQuebraEspecial, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idadeAnoRealizacao, report),
            },
            //{
            //    colSpan: 4,
            //    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.mesAnoInicioAcumulacaoQuebraEspecial, report),
            //},
            //{
            //    colSpan: 4,
            //    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.mesAnoFimAcumulacaoQuebraEspecial, report),
            //},
            {
                colSpan: 6,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.periodoAcumulacao, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.qtdeAportes, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.valorAporteProjetoVidaSonho, report),
            },
        ]

        return (

            //<div
            //    {...props}
            //>
            <>
                <TableExibeDados
                    report={report}
                >
                    <TableHeadExibeDados
                        report={report}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estudo.current.projetoVidaSonhoTracarMeta?.map((item, ind) => {
                            return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[0].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {item.nomeCurtoFamiliarFormatado}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[1].colSpan}
                                    >
                                        {item.descricaoFormatado}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[2].colSpan}
                                    >
                                        {item.valor}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[3].colSpan}
                                    >
                                        {item.valorAcumulacaoJaRealizadoVFValorAcumulacaoNecessarioVP}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[4].colSpan}
                                    >
                                        {item.valorAcumulacaoPendente}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[5].colSpan}
                                    >
                                        {item.idadeAnoRealizacao}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[6].colSpan}
                                    >
                                        {item.periodoAcumulacao/*mesAnoInicioAcumulacao*/}
                                    </TableCellBodyExibeDados>
                                    
                                    {/*
                                    <TableCellBodyExibeDados
                                        colSpan={headList[7].colSpan}
                                    >
                                        {item.mesAnoFimAcumulacao}
                                    </TableCellBodyExibeDados>
                                    */}

                                    <TableCellBodyExibeDados
                                        colSpan={headList[7/*8*/].colSpan}
                                    >
                                        {item.qtdeAportes}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[8/*9*/].colSpan}
                                    >
                                        {item.valorAporteProjetoVidaSonhoFormatado}
                                    </TableCellBodyExibeDados>
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>
                <div
                    className='mt-5'
                    dangerouslySetInnerHTML={{ __html: MESSAGE().projetoVidaSonhoTracarMetaImportante}}
                />
            </>
            //</div>
        )
    }



    const CardGridEstudoAux = values.modoApresentacao ? GridItem12 : CardGridEstudo



    return (
        estudo.current.projetoVidaSonhoTracarMeta &&
        estudo.current.projetoVidaSonhoTracarMeta.length > 0 && (
            report
                ?
                    <ProjetoVidaSonhoTracarMeta
                        //className='mt-5' // mudança da fonte
                        //className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte
                    />
                :
                    <GridContainer
                        className='justify-center'
                    >
                        <GridItem11>
                            <CardGridEstudoAux>
                                <CardGridEstudoTabelaPadrao
                                    values={values}
                                    SvgIcon={''}
                                    label={LABEL.projetoVidaSonhoTracarMeta}
                                    helpTextMorte={''}
                                    helpTextInvalidez={''}
                                    component={<ProjetoVidaSonhoTracarMeta/>}
                                    popup={false}
                                    nameListaMoreLess={moreLessList}
                                    listaMoreLess={moreLessList ? values[moreLessList] : ''}
                                    idListaMoreLess={HARDCODE.estudoFormProjetoVidaSonhoTracarMeta}
                                    setFieldValue={setFieldValue}
                                />
                            </CardGridEstudoAux>
                        </GridItem11>
                    </GridContainer>
        ) 
    )
}

export default EstudoFormProjetoVidaSonhoTracarMeta